interface SplitName {
  firstName: string;
  lastName: string;
}

// Last-resort split for a combined "full name" string into firstName/lastName —
// only used when neither a real form nor a social provider gave us the two
// separately (e.g. Facebook without profile data, or a pre-existing displayName).
// Imperfect for Spanish double names/surnames on purpose: there's no reliable
// automatic way to know "Johan Alejandro Marin Mondragon" should split as
// "Johan Alejandro" / "Marin Mondragon" rather than "Johan" / "Alejandro Marin
// Mondragon" — this is a fallback, not a substitute for provider-given names.
export function splitFullName(fullName: string | null | undefined): SplitName {
  const trimmed = (fullName || '').trim();
  if (!trimmed) return { firstName: '', lastName: '' };
  const spaceIndex = trimmed.indexOf(' ');
  if (spaceIndex === -1) return { firstName: trimmed, lastName: '' };
  return {
    firstName: trimmed.slice(0, spaceIndex),
    lastName: trimmed.slice(spaceIndex + 1).trim()
  };
}
